import request from '@/api/config/request'

const prex = "api/admin/gestao/";

export function getFechamentoMensal() {
    return request({
        url: `${prex}fechamento`,
        method: 'get',
    })
}

export function setFechamentoMensal(data) {
    return request({
        url: `${prex}fechamento`,
        method: 'post',
        data
    })
}